/*
  <hero-slideshow>: crossfading image slideshow for the landing hero.
  Autoplays every data-interval ms, pauses on hover/focus and when the tab is
  hidden, dots jump to a slide. With reduced motion it stays on the first image
  (the dots still work).
*/
if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dots.forEach((dot) => dot.addEventListener('click', () => {
        this.show(parseInt(dot.dataset.slideDot, 10));
        this.restart();
      }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      // Swipe on touch devices
      let startX = null;
      this.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (startX === null) return;
        const delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) { this.show(this.index + (delta < 0 ? 1 : -1)); this.restart(); }
        startX = null;
      });

      // Theme editor: show the selected slide block
      document.addEventListener('shopify:block:select', (event) => {
        const position = this.slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
        if (position >= 0) { this.stop(); this.show(position); }
      });

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    show(index) {
      const count = this.slides.length;
      this.index = (index + count) % count;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    start() {
      if (this.reduced || this.timer || this.slides.length < 2) return;
      this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() { clearInterval(this.timer); this.timer = null; }

    restart() { this.stop(); this.start(); }
  });
}
